import { TierPage } from '@/modules/tiers/components/tier-page'

export const TierView = () => {
  return <TierPage />
}
